import { render, staticRenderFns } from "./cxInstantClaim.vue?vue&type=template&id=3429c88e&scoped=true&"
import script from "./cxInstantClaim.vue?vue&type=script&lang=js&"
export * from "./cxInstantClaim.vue?vue&type=script&lang=js&"
import style0 from "./cxInstantClaim.vue?vue&type=style&index=0&id=3429c88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429c88e",
  null
  
)

export default component.exports